var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toUrlParams } from "../../shared/JSONRequest";
import rison from 'rison-node';
import { SearchBar } from "../Library/components/SearchBar";
import ConnectionSearchBar from "../ConnectionsList/components/SearchBar";
import { Loader } from "../components/Elements/Loader";
import Footer from "../App/Footer";

import { NeedAuthorization } from "../Auth";
import { t, Translate } from "../I18N";
import { DocumentCounter } from "./DocumentCounter";
import { Icon } from "../UI";
import { withRouter } from "../componentWrappers";
import { LibraryHeader } from "../Library/components/LibraryHeader";
import { risonDecodeOrIgnore } from "../utils";
import Welcome from "./components/Welcome";
import { TilesViewer } from "./TilesViewer";
import blankState from "../Library/helpers/blankState";

const selectAllEntities = (command) => {
  command.selectAllDocuments();
};
class DocumentsList extends Component {
  static getDerivedStateFromProps(newProps, prevState) {
    const { scrollCount = 0, parentScrollCount = 0 } = prevState;
    if (newProps.scrollCount !== parentScrollCount) {
      return {
        loading: false,
        scrollCount: scrollCount + 1,
        parentScrollCount: newProps.scrollCount
      };
    }

    return { loading: false };
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      scrollCount: 0,
      parentScrollCount: 0
    };
    this.clickOnDocument = this.clickOnDocument.bind(this);
    this.selectAllDocuments = this.selectAllDocuments.bind(this);
    this.loadNextGroupOfEntities = this.loadNextGroupOfEntities.bind(this);
  }

  loadMoreDocuments(amount, from) {
    this.setState({ loading: true });
    this.props.loadMoreDocuments(amount, from, this.props.location, this.props.navigate);
  }

  selectAllDocuments() {
    if (this.props.selectAllDocuments) {
      this.props.selectAllDocuments.apply(this);
    }
  }

  clickOnDocument(...args) {
    if (this.props.clickOnDocument) {
      this.props.clickOnDocument.apply(this, args);
    }
  }

  loadNextGroupOfEntities() {
    const from = this.props.documents.get('rows').size;
    const DEFAULT_PAGE_SIZE = 30;
    if (from) {
      this.loadMoreDocuments(DEFAULT_PAGE_SIZE, from);
    }
  }

  loadMoreButton(amount) {
    const query = _objectSpread({}, this.props.location.query);
    const q = query.q ? risonDecodeOrIgnore(query.q) : {};
    const from = this.props.documents.get('rows').size;
    q.from = from;
    q.limit = amount;
    query.q = rison.encode(q);
    const url = `${this.props.location.pathname}${toUrlParams(query)}`;
    return (/*#__PURE__*/
      _jsx(Link, {
        to: url,
        className: "btn btn-default btn-load-more",
        onClick: (e) => {
          e.preventDefault();
          this.loadMoreDocuments(amount, from);
        } }, void 0,

      amount, " ", t('System', 'x more')
      ));

  }

  relationshipsToolbar(counter) {
    const SortButtonsRelationships = this.props.SortButtons;
    const SearchBarRelationships = this.props.SearchBar;

    return (/*#__PURE__*/
      _jsx("div", { className: "relationship-toolbar" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "search-list" }, void 0, /*#__PURE__*/
      _jsx(SearchBarRelationships, {})
      ), /*#__PURE__*/
      _jsx("div", { className: "sort-by" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "documents-counter-sort" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "sorted by")
      ), /*#__PURE__*/
      _jsx(SortButtonsRelationships, {
        sortCallback: this.props.searchDocuments,
        selectedTemplates: this.props.filters.get('documentTypes'),
        stateProperty: this.props.sortButtonsStateProperty }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "documents-counter" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "documents-counter-label" }, void 0, counter)
      )
      ));

  }

  render() {
    const {
      documents,
      connections,
      GraphView,
      view,
      hideFooter,
      connectionsGroups,
      LoadMoreButton,
      rowListZoomLevel,
      CollectionViewer
    } = this.props;

    const totalConnections = connections ?
    connectionsGroups.reduce(
      (total, g) =>
      total +
      g.get('templates').reduce((count, template) => count + template.get('count'), 0),
      0
    ) :
    undefined;

    const counter = /*#__PURE__*/
    _jsx(DocumentCounter, {
      selectedEntitiesCount: this.props.selectedDocuments.size,
      entityListCount: this.props.documents.get('rows').size,
      entityTotal: documents.get('totalRows'),
      hitsTotalRelation: documents.get('relation'),
      totalConnectionsCount: totalConnections }
    );


    const FooterComponent = !hideFooter ? /*#__PURE__*/_jsx(Footer, {}) : null;

    const libraryContent = () => {
      if (view !== 'graph') {
        return (/*#__PURE__*/
          React.createElement(CollectionViewer, {

            rowListZoomLevel,
            storeKey: this.props.storeKey,
            clickOnDocument: this.clickOnDocument,
            onSnippetClick: this.props.onSnippetClick,
            deleteConnection: this.props.deleteConnection,
            loadNextGroupOfEntities: this.loadNextGroupOfEntities }

          ));

      }
      if (view === 'graph') {
        return /*#__PURE__*/_jsx(GraphView, { clickOnDocument: this.clickOnDocument });
      }
      return null;
    };
    const loadMoreSection = /*#__PURE__*/
    _jsx("div", { className: "row" }, void 0,
    (() => {
      if (view !== 'graph') {
        return /*#__PURE__*/_jsx("p", { className: "text-center col-sm-12 documents-counter" }, void 0, counter);
      }
      return null;
    })(),
    (() => {
      if (LoadMoreButton) {
        return /*#__PURE__*/_jsx(LoadMoreButton, {});
      }
      if (documents.get('rows').size < documents.get('totalRows') && !this.state.loading) {
        return (/*#__PURE__*/
          _jsx("div", { className: "text-center col-sm-12" }, void 0,
          this.loadMoreButton(30), " ", this.loadMoreButton(300)
          ));

      }
      if (this.state.loading) {
        return /*#__PURE__*/_jsx(Loader, {});
      }
      return null;
    })(), /*#__PURE__*/
    _jsx(NeedAuthorization, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "text-center col-sm-12 force-ltr protip" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "lightbulb" }), ' ', /*#__PURE__*/
    _jsx("b", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "ProTip!")
    ), /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Use"), "\xA0", /*#__PURE__*/
    _jsx("span", { className: "protip-key", "no-translate": "true" }, void 0, "cmd"

    ), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "or"), ' ', /*#__PURE__*/
    _jsx("span", { className: "protip-key", "no-translate": "true" }, void 0, "shift"

    ), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "+ click to select multiple cards.")
    )
    )
    )
    );


    return (/*#__PURE__*/
      _jsx("div", { className: "documents-list" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "main-wrapper" }, void 0,
      this.props.SortButtons === undefined && /*#__PURE__*/
      _jsx(LibraryHeader, {
        storeKey: this.props.storeKey,
        counter: counter,
        selectAllDocuments: () => {
          selectAllEntities(this);
        },
        SearchBar: this.props.SearchBar,
        searchCentered: this.props.searchCentered,
        filters: this.props.filters,
        tableViewMode: this.props.tableViewMode,
        scrollCount: this.state.scrollCount }
      ),

      this.props.SortButtons !== undefined && this.relationshipsToolbar(counter),

      blankState() && /*#__PURE__*/_jsx(Welcome, {}),

      CollectionViewer.wrapLoader && /*#__PURE__*/
      _jsx("div", {
        className: "library-load-container",
        onScroll: () => {
          this.setState((prevState, _props) => ({
            scrollCount: prevState.scrollCount + 1
          }));
        } }, void 0,

      libraryContent(),
      loadMoreSection
      ),

      !CollectionViewer.wrapLoader && /*#__PURE__*/
      React.createElement(React.Fragment, null,
      libraryContent(),
      loadMoreSection
      ),


      FooterComponent
      )
      ));

  }
}

DocumentsList.defaultProps = {
  SearchBar,
  rowListZoomLevel: 0,
  CollectionViewer: TilesViewer,
  selectedDocuments: {},
  tableViewMode: false,
  scrollCount: 0,
  SortButtons: undefined
};







































export { DocumentsList };

export default withRouter(DocumentsList);